<template>
  <div>
    <h4 class="mb-2">{{$t('printers.modal.confirmJobCancel.title', {fileName, printerName})}}</h4>

    <div class="text-center mt-4" v-if="printer">
      <camera-live-view :printer-id="printer.printer_id" :webcam-id="printer.webcam_id"></camera-live-view>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  import CameraLiveView from "../camera/CameraLiveView";
  import PrinterMixin from "@/mixins/printer";

  export default {
    name: 'confirm-job-cancel',
    components: {CameraLiveView},
    mixins: [
      PrinterMixin
    ],
    props: {
      jobId: {
        type: [Number, String],
        required: true
      },
      printerId: {
        type: [Number, String],
        required: true
      }
    },
    data() {
      return {
        job: null,
        printer: null
      }
    },
    created() {
      //Find job data
      const jobIndex = this.getJobIndex(this.jobId);
      if (jobIndex >= 0) {
        this.job = this.getJobs[jobIndex];
      }
      //Find printer data
      const printerIndex = this.getPrinterIndex(this.printerId);
      if (printerIndex >= 0) {
        this.printer = this.getPrinters[printerIndex];
      }
    },
    computed: {
      ...mapGetters(["getJobIndex","getJobs","getPrinterIndex","getPrinters"]),

      printerName() {
        return this.printer ? this.calculatePrinterName(this.printer) : 'Undefined';
      },

      fileName() {
        return this.job ? this.job.filename : 'Undefined';
      }
    },
    methods: {
      ...mapActions(["cancelJob"]),

      handleCancelJob(callback) {
        this.cancelJob({printerId: this.printerId, jobId: this.jobId}).then(({data}) => {
          if (data.result) {
            if (callback) callback();
          } else {
            this.msgBoxOk(data.message);
          }
        }).catch(() => {
          this.msgBoxOk(this.$t('printers.modal.confirmJobCancel.errorCancelJob', {jobId: this.jobId}));
        });
      }
    }
  }
</script>